import { render, staticRenderFns } from "./Hotelkontingent.vue?vue&type=template&id=187e624c"
import script from "./Hotelkontingent.vue?vue&type=script&lang=js"
export * from "./Hotelkontingent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports